import { matchPath } from "react-router-dom";
import { context } from "../../wr-context";
export var isPathMatch = function(routeKey) {
    var routeDefinition = context.routes.find(function(route) {
        return route.key === routeKey;
    });
    if (!routeDefinition) {
        return false;
    }
    var match = matchPath(context.history.location.pathname, routeDefinition);
    return Boolean(match);
};
